'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _starRating = require('star-rating');

var _profileBadge = require('../../../profile-badge');

var _specialtySvgIcon = require('../../../specialty-svg-icon');

var _svgIcon = require('../../../svg-icon');

var _helpers = require('../../../../src/client/utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rearrangeSubspecialties = function rearrangeSubspecialties(subspecialties, selectedKeyword) {
    var index = subspecialties.indexOf(selectedKeyword);
    var cloneOfSubspecialties = subspecialties.slice(0);
    if (index > -1) {
        var rearrangedSubspecialty = cloneOfSubspecialties.splice(index, 1);
        var newArray = rearrangedSubspecialty.concat(cloneOfSubspecialties);
        return newArray.join(', ');
    } else {
        return subspecialties.join(', ');
    }
};

var ProfileDetails = function (_React$Component) {
    (0, _inherits3.default)(ProfileDetails, _React$Component);

    function ProfileDetails(props) {
        (0, _classCallCheck3.default)(this, ProfileDetails);

        var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

        _this.state = {
            peerIconHovered: false
        };

        _this.togglePeerIconHovered = _this.togglePeerIconHovered.bind(_this);
        return _this;
    }

    ProfileDetails.prototype.togglePeerIconHovered = function togglePeerIconHovered(value) {
        this.setState({
            peerIconHovered: value
        });
    };

    ProfileDetails.prototype.render = function render() {
        var _this2 = this;

        var profileName = this.props.profileName + (this.props.networks && this.props.networks.length && '.' || '');
        var profileImage = this.props.profileImage || this.props.specialtyIcon || 'https://www.doctify.com/images/athena-uk/static/icons/specialty-icons/specialty.svg';

        var shouldRenderSvg = profileImage && profileImage.includes('specialty-icons') || false;

        var peerIcon = this.state.peerIconHovered ? 'peer_recommendation_negative' : 'peer_recommendation';

        var showBadge = this.props.isCore || this.props.videoConsultation;

        var query = {
            hospitalList: this.props.selectedHospitalListId,
            network: this.props.searchedNetwork
        };
        var linkToProfile = (0, _helpers.getLink)(this.props.profileUrl, query);

        var peerRecommendationQuery = (0, _extends3.default)({}, query, {
            scrollToPeerRecommendations: true
        });
        var linkToPeerRecommendations = (0, _helpers.getLink)(this.props.profileUrl, peerRecommendationQuery);

        return _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-6 col-md-7' },
            _react2.default.createElement(
                _reactRouter.Link,
                { to: linkToProfile },
                shouldRenderSvg && _react2.default.createElement(_specialtySvgIcon.SpecialtySvgIcon, {
                    specialtyIconUri: profileImage,
                    className: _style2.default.profileImage + ' ' + _style2.default['profile-image_svg']
                }) || _react2.default.createElement('img', {
                    className: _style2.default.profileImage,
                    src: profileImage,
                    alt: profileName
                })
            ),
            showBadge && _react2.default.createElement(
                'div',
                { className: _style2.default.profileBadgeContainer },
                _react2.default.createElement(_profileBadge.ProfileBadge, {
                    isSmall: true,
                    isCore: this.props.isCore,
                    isVideoConsultation: this.props.videoConsultation
                })
            ),
            _react2.default.createElement(
                'div',
                { className: _style2.default.profileInformations + ' ' + (showBadge ? _style2.default.profileInformationsBadge : '') },
                _react2.default.createElement(
                    'h2',
                    null,
                    _react2.default.createElement(
                        _reactRouter.Link,
                        {
                            to: linkToProfile,
                            className: this.props.profileType === 'specialist' && _style2.default.specialistName || _style2.default.practiceName
                        },
                        profileName
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _style2.default.meta },
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default.starRating },
                        _react2.default.createElement(_starRating.StarRating, {
                            averageRating: this.props.averageRating })
                    ),
                    this.props.peerRecommendations ? _react2.default.createElement(
                        _reactRouter.Link,
                        {
                            to: linkToPeerRecommendations,
                            className: _style2.default.peerRecommendations,
                            onMouseEnter: function onMouseEnter() {
                                return _this2.togglePeerIconHovered(true);
                            },
                            onMouseLeave: function onMouseLeave() {
                                return _this2.togglePeerIconHovered(false);
                            }
                        },
                        _react2.default.createElement(_svgIcon.SvgIcon, {
                            className: _style2.default.peerRecommendationIcon,
                            icon: peerIcon
                        })
                    ) : null,
                    _react2.default.createElement(
                        'p',
                        { className: _style2.default.location },
                        _react2.default.createElement('i', { className: 'ion-ios-location' }),
                        this.props.relatedPracticeName && _react2.default.createElement(
                            'span',
                            null,
                            this.props.relatedPracticeName,
                            ' - '
                        ) || null,
                        _react2.default.createElement(
                            'span',
                            null,
                            this.props.distance != null && Number(this.props.distance) + ' miles' || 'Location unavailable'
                        )
                    )
                ),
                this.props.specialty && _react2.default.createElement(
                    'p',
                    { className: _style2.default.specialty },
                    _react2.default.createElement(_specialtySvgIcon.SpecialtySvgIcon, {
                        className: _style2.default.icon,
                        specialtyIconUri: this.props.specialtyIcon
                    }),
                    _react2.default.createElement(
                        'span',
                        null,
                        this.props.specialty
                    )
                ),
                this.props.subspecialties && this.props.subspecialties.length ? _react2.default.createElement(
                    'p',
                    { className: _style2.default.subspecialty },
                    _react2.default.createElement(
                        'span',
                        null,
                        this.props.selectedKeyword !== this.props.specialty && rearrangeSubspecialties(this.props.subspecialties, this.props.selectedKeyword) || this.props.subspecialties.join(', ')
                    )
                ) : null
            )
        );
    };

    return ProfileDetails;
}(_react2.default.Component);

ProfileDetails.propTypes = {
    peerIconHovered: require('react').PropTypes.any.isRequired
};


ProfileDetails.defaultProps = {
    subspecialties: []
};
exports.default = ProfileDetails;


// WEBPACK FOOTER //
// ./components/search-results/lib/components/profile-details.js